/*
  10X shared motion utility.
  - Scroll-triggered reveals: elements with [data-10x-reveal] fade/translate up
    on entry. Optional [data-10x-reveal-delay] staggers siblings.
  - Subtle parallax: [data-10x-parallax] shifts slowly against scroll.
  Honors prefers-reduced-motion: with it set, everything shows immediately and
  parallax is disabled. Built once, reused per section per the blueprint.
*/
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('[data-10x-reveal]');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce) return;
    var els = document.querySelectorAll('[data-10x-parallax]');
    if (!els.length) return;

    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var viewport = window.innerHeight || document.documentElement.clientHeight;
        // -1..1 as the element travels through the viewport
        var progress = (rect.top + rect.height / 2 - viewport / 2) / viewport;
        var factor = parseFloat(el.getAttribute('data-10x-parallax')) || 0.12;
        el.style.transform = 'translate3d(0,' + (progress * factor * 100).toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function initHeaderScroll() {
    var header = document.querySelector('[data-10x-header]');
    if (!header) return;
    var hero = document.querySelector('[data-10x-hero]');
    if (!hero) {
      // No hero to be transparent over (e.g. the Apply page, OS-742): the
      // on-load transparent state assumes a hero behind it, so a page
      // without one gets the solid/scrolled state immediately.
      header.classList.add('is-scrolled');
      return;
    }

    // NAV SCROLL FADE, B7 (round 2b, 2026-08-29): "the nav background fades
    // to solid #000 (~250ms) AS SOON AS scrolling starts (scrollY > 0)" --
    // was an IntersectionObserver keyed off the hero fully scrolling past
    // (scrolledPast at entry.boundingClientRect.bottom <= 0), which only
    // fired ~800-900px into the page, read on live as "never implemented."
    // A plain scroll listener at the literal scrollY > 0 threshold.
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() { initReveal(); initParallax(); initHeaderScroll(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
